import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import * as conversor from './useConverterPropostaEmItens';
import { criarConversorPorFamilia, type CriarPedidoParams, type CriarPedidosResult } from '../../../backend/src/services/propostas/criar-por-familia';
export type { CriarPedidoParams, CriarPedidosResult, PedidoCriado } from '../../../backend/src/services/propostas/criar-por-familia';
export const { criarPedidosPorFamilia } = criarConversorPorFamilia(supabase, conversor);

export function useCriarPedidosPorFamilia() {
  const criarPedidos = async (params: CriarPedidoParams): Promise<CriarPedidosResult> => {
    console.log('[useCriarPedidosPorFamilia] Iniciando criação de pedidos:', {
      clienteId: params.clienteId,
      totalLinhas: params.composicao?.linhas?.length || 0,
    });

    const result = await criarPedidosPorFamilia(params);

    if (result.success && result.precisouDividir) {
      toast.success('2 pedidos criados!', {
        description: 'Proposta dividida em FIXA e MÓVEL para tramitação independente',
      });
    } else if (result.success && result.pedidos.length === 1) {
      toast.success(`${result.totalItens} item(ns) criado(s)`);
    } else if (!result.success) {
      toast.error('Erro ao criar pedidos', {
        description: result.errors[0],
      });
    }

    return result;
  };

  return { criarPedidos };
}
